/**
 * This file is auto generated by running yarn build
 * DO NOT EDIT THIS FILE MANUALLY
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

var svgNode = function svgNode(_ref) {
  var fill = _ref.fill;
  return React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), React.createElement("path", {
    d: "M24 24V0H0v24z"
  }), React.createElement("path", {
    fill: fill || "#FFF",
    fillRule: "nonzero",
    d: "M17.29 9.29c.39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L12 13.17l3.88-3.88c.39-.39 1.03-.38 1.41 0z"
  })));
};

svgNode.displayName = "svgNode";
export default createSvgIcon(svgNode);